import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-pr-overlay',
    templateUrl: './pr-overlay.component.html',
    styleUrls: ['./pr-overlay.component.scss'],
    standalone: true
})
export class PrOverlayComponent implements OnInit {

  @Output() closeOverlay = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onCloseOverlay() {
    this.closeOverlay.emit();
  }
}
